import { EventEmitter } from 'events'
import { JobWizardMobile } from 'sprockets_react/job_wizards/registries'

JobWizardMobile.StepSequence = {

  defaultSequence() {
    const wizard = JobWizardMobile
    const steps = [
      wizard.SelectCategory,
      wizard.SelectLocation,
      wizard.EnterDescription,
      ...loginSteps(),
      ...displayContactStep(),
      ...displayVerifyStep(),
      wizard.AddAttachment,
      wizard.GetContactPreference,
      wizard.ChooseSchedule,
      wizard.ChooseBudget,
      wizard.BudgetPrice,
      wizard.ChooseSiteVisit,
      wizard.SiteVisitTime,
      wizard.JobSummary,
      wizard.CheckJobDuplicate,
      wizard.SubmitJob,
      wizard.HasJobBeenDoneYet,
      wizard.WhoDidTheJob,
      wizard.RateExperience,
      wizard.HowMuchDidYouPay,
      wizard.SubmitFeedback,
      wizard.PostJobAgain
    ]

    function loginSteps() {
      return SS.appFn.userLoggedIn() ? [] : [ wizard.EnterEmailAddress, wizard.EnterPassword, wizard.GetFirstName, wizard.GetContact ]
    }

    function displayContactStep() {
      return (SS.appFn.userLoggedIn() && SS.appFn.userHasPhoneForCurrentFlow())  ? [] : [ wizard.CanCall ]
    }

    function displayVerifyStep() {
      return (SS.appFn.userLoggedIn() && SS.appFn.userHasVerifiedPhone()) ? [] : [ wizard.VerifyNumber ]
    }

    return steps
  },

  removeStep(position) {
    let currentSteps = JobWizardMobile.Steps
    JobWizardMobile.Steps = [...currentSteps.slice(0, position), ...currentSteps.slice(position + 1)]
  },

  removeStepByType(stepType) {
    let position = JobWizardMobile.Steps.indexOf(stepType)

    if (position === -1) { return }

    this.removeStep(position)
  },

  init() {
    JobWizardMobile.Emitter = JobWizardMobile.Emitter || new EventEmitter()
    JobWizardMobile.Steps = JobWizardMobile.StepSequence.defaultSequence()
  }
}
